<template>
  <img src="/img/payments/klarna.png" width="51" height="11" alt="Klarna">
</template>
